import React, { useCallback, useState } from "react";
import * as Immutable from "immutable";
import styled, { css } from "styled-components";
import { Field } from "formik";
import copyToClipboard from "util/copyToClipboard";
import { DropdownButton, InputGroup, FormGroup, MenuItem, DeleteMenuItem } from "components/bootstrap";
import TypeSpecificParameterInput from "enterprise/parameters/components/TypeSpecificParameterInput";
import useParametersMap from "views/hooks/useParametersMap";
import ParameterDeclarationForm from "./ParameterDeclarationForm";
const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 0;
`;
const StyledDropdownButton = styled(DropdownButton)(
  ({ theme, $hasError }) => `
  ${$hasError ? css`
          && {
            border: 1px solid ${theme.colors.variant.light.danger};
            border-right: 0;
          }
        ` : ""}
`
);
const Parameter = ({ parameter, searchId, onDelete, onEdit, inputSize = "small" }) => {
  const [showDeclarationForm, setShowDeclarationForm] = useState(false);
  const { name: parameterName, title } = parameter;
  const parameters = Immutable.fromJS({ [parameterName]: parameter });
  const fieldName = `parameterBindings.${parameterName}`;
  const existingParameters = useParametersMap();
  const existingParametersWithoutCurrentOne = existingParameters.remove(parameterName);
  const toggleDeclarationForm = useCallback(() => {
    setShowDeclarationForm((cur) => !cur);
  }, []);
  const handleDelete = useCallback(() => {
    onDelete(parameterName, fieldName);
  }, [onDelete, fieldName, parameterName]);
  const handleUpdate = useCallback(
    (newParameters) => {
      const newParameter = newParameters.get(parameterName);
      toggleDeclarationForm();
      return onEdit(parameterName, newParameter);
    },
    [onEdit, parameterName, toggleDeclarationForm]
  );
  const onValueChange = useCallback(
    (name, onChange) => (_, newValue) => onChange({
      target: { name, value: newValue }
    }),
    []
  );
  const copyParameterNameToClipboard = useCallback(() => copyToClipboard(`$${parameterName}$`), [parameterName]);
  return /* @__PURE__ */ React.createElement(Field, { name: fieldName }, ({ field: { onChange, onBlur, value, name }, meta: { error } }) => /* @__PURE__ */ React.createElement(StyledFormGroup, { controlId: `form-inline-${name}`, validationState: error ? "error" : null, bsSize: inputSize }, /* @__PURE__ */ React.createElement(InputGroup, { bsSize: inputSize }, /* @__PURE__ */ React.createElement(InputGroup.Button, null, /* @__PURE__ */ React.createElement(StyledDropdownButton, { id: `parameter-dropdown-${name}`, bsSize: "small", $hasError: !!error, title }, /* @__PURE__ */ React.createElement(MenuItem, { key: "edit", onSelect: toggleDeclarationForm }, "Edit"), /* @__PURE__ */ React.createElement(DeleteMenuItem, { key: "delete", onSelect: handleDelete }), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(MenuItem, { key: "copy", onSelect: copyParameterNameToClipboard }, "Copy to clipboard"))), /* @__PURE__ */ React.createElement(
    TypeSpecificParameterInput,
    {
      parameter,
      value: value != null ? value : "",
      inputSize,
      onChange: onValueChange(name, onChange),
      onBlur,
      searchId
    }
  ), showDeclarationForm && /* @__PURE__ */ React.createElement(
    ParameterDeclarationForm,
    {
      existingParameters: existingParametersWithoutCurrentOne,
      parameters,
      onClose: toggleDeclarationForm,
      onSave: handleUpdate
    }
  ))));
};
export default Parameter;
